module.exports = __webpack_public_path__ + "img/AFMS_PANIC_ON.9fdf318e.png";